import NumberRangeApi from "../../../api/masterData/numberRangeApi";

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async addOrUpdate({ dispatch }, values) {
      try {
        const response = await NumberRangeApi.addOrUpdate(values);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchById({ dispatch }, {id}) {
      try {
        const response = await NumberRangeApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async getNext({ dispatch }, { id }) {
      try {
        const response = await NumberRangeApi.getNext(id);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
